import { useQuery } from "@tanstack/react-query";
import {
  inspecaoService,
  InspecaoTempoMedioParams,
  InspecaoTempoMedioResponse,
  InspecaoSnapshotParams,
  InspecaoSnapshotResponse,
} from "../services/inspecaoService";

export const useInspecaoTempoMedio = (params: InspecaoTempoMedioParams) => {
  return useQuery<InspecaoTempoMedioResponse>({
    queryKey: ["inspecao-tempo-medio", params],
    queryFn: () => inspecaoService.getTempoMedio(params),
    enabled: !!params.dataInicio && !!params.dataFim,
  });
};

export const useInspecaoSnapshots = (params: InspecaoSnapshotParams | null) => {
  return useQuery<InspecaoSnapshotResponse[]>({
    queryKey: ["inspecao-snapshots", params],
    queryFn: () => inspecaoService.getSnapshots(params!),
    enabled: !!params?.dataInicio && !!params?.dataFim,
  });
};
